import { IconChevronDown, IconChevronUp } from "@/components/icons";
import {
  sameSubmissionsSortKey,
  toggleSubmissionsSort,
  type SubmissionsSortKey,
  type SubmissionsSortState,
} from "@/lib/forms/submissionsTableView";

interface SubmissionsSortHeaderProps {
  label: string;
  sortKey: SubmissionsSortKey;
  sort: SubmissionsSortState;
  onSortChange: (next: SubmissionsSortState) => void;
  className?: string;
}

export function SubmissionsSortHeader({
  label,
  sortKey,
  sort,
  onSortChange,
  className,
}: SubmissionsSortHeaderProps) {
  const active = sameSubmissionsSortKey(sort.key, sortKey);

  return (
    <th
      className={[
        "max-w-[10.5rem] px-3 py-2 text-left font-onest text-[11px] font-semibold uppercase tracking-wide text-slate-500",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      title={label}
    >
      <button
        type="button"
        title={label}
        onClick={() => onSortChange(toggleSubmissionsSort(sort, sortKey))}
        className={[
          "inline-flex w-full min-w-0 max-w-full items-center gap-1 rounded-md px-0.5 py-0.5 text-left uppercase tracking-wide transition-colors",
          active
            ? "text-brand-700 hover:bg-brand-50"
            : "text-slate-500 hover:bg-slate-100 hover:text-slate-700",
        ].join(" ")}
      >
        <span className="min-w-0 truncate">{label}</span>
        {active ? (
          sort.dir === "asc" ? (
            <IconChevronUp size={14} className="shrink-0 text-brand-600" />
          ) : (
            <IconChevronDown size={14} className="shrink-0 text-brand-600" />
          )
        ) : null}
      </button>
    </th>
  );
}
